export default "__VITE_ASSET__Ddh5QrEP__";